import { CultureInfo } from '../culture-info.model';
import { CultureInfoFr } from './fr';

/**
 * @ignore
 */
export const CultureInfoFrPM: CultureInfo = {
  name: 'fr-PM',
  displayName: 'français (Saint-Pierre-et-Miquelon)',
  iso3LanguageCode: 'fra',
  iso2LanguageCode: 'fr',
  ietfLanguageTag: 'fr-PM',
  parent: CultureInfoFr
};
